module.exports = __webpack_public_path__ + "img/allianz.48983e73.jpg";